export default __webpack_public_path__ + "static/media/kayaguneriki4.17ae8a69.jpg";